import { render, staticRenderFns } from "./EmptyDetailCard.vue?vue&type=template&id=2c5b6e06"
import script from "./EmptyDetailCard.vue?vue&type=script&lang=js"
export * from "./EmptyDetailCard.vue?vue&type=script&lang=js"
import style0 from "./EmptyDetailCard.vue?vue&type=style&index=0&id=2c5b6e06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports